module.exports = __webpack_public_path__ + "img/Bahnhof_Oravita_5kl.6b875d1b.jpg";